import { Component, OnInit, ViewChild } from '@angular/core';


import { MatTableDataSource, MatSort, MatDialog, MatPaginator } from '@angular/material';
import { Router } from '@angular/router';

import { ChurchService } from '@asambleas-services/church/church.service';
import { Minister } from '@asambleas-models/minister.model';
import { ConceptValues } from '@asambleas-models/concept-values.model';
import { MinisterService } from '@asambleas-services/minister/minister.service';
import { GeneralService } from '@asambleas-services/general/general.service';
import { LoadService } from '@asambleas-components/loader/loader.service';
import { Concept } from '@asambleas-models/concept.model';
import { Church } from '@asambleas-models/church.model';
import { Angular5Csv } from 'angular5-csv/Angular5-csv';
import { District } from '@asambleas-models/district.model';
import { Sectional } from '@asambleas-models/sectional.model';
import { RegistrationService } from '@asambleas-services/registration/registration.service';
import { IglesiasService } from '@asambleas-services/iglesias/iglesias.service';
import { LoginService } from '@asambleas-services/login/login.service';
import { RolesService } from '@asambleas-services/roles/roles.service';
import { Role } from '@asambleas-models/role.model';
import { AxisDistrictDirector } from '@asambleas-models/AxisDistrictDirector';
import { SectionalCoordinatorPastoral } from '@asambleas-models/SectionalCoordinatorPastoral';


// import {MinisterDataSource} from '../../../../services/minister/minister..datasource';

@Component({
    selector: 'app-minister-list',
    templateUrl: './minister-list.component.html',
    styleUrls: ['./minister-list.component.scss']
})
export class MinisterListComponent implements OnInit {
    // Defines if all the needed resources has load
    resourcesHasLoaded: boolean = false;

    isAuthorized = true;
    allMinisters: Minister[] = [];
    ministersResult: Minister[] = [];

    ministerStates: ConceptValues;
    ministerStateValue: string = 'Todos';
    ministerStateObjValue: ConceptValues;
    fulfillmentStates: ConceptValues;
    fulfillmentStateValue: string = 'Todos';
    inputFilterValue: string;

    ministerLevels: ConceptValues;
    ministerLevelValue: string = 'Todos';
    ministerLevelObjValue: ConceptValues;

    churchesSelected: Church[] = [];


    //displayedColumns = ['name', 'church', 'state', 'level'];
    displayedColumns = ['name', 'church', 'state', 'level', 'postulacion'];

    dataSource = new MatTableDataSource(this.ministersResult);
    // dataSource: MinisterDataSource;

    loader: any;
    isModalOpen: boolean = false;

    //FILTROS
    districts: District[] = [];
    sectionals: Sectional[] = [];
    cities: any[] = [];
    churches: Church[] = [];

    districtValue: number;
    sectionalValue: number;
    cityValue: number;
    churchValue: number;

    ministerialTrainingTypes: ConceptValues;

    firstTimeFiltered: boolean = false;    // VARIABLE AUXILIAR PARA SABER SI YA FUE FILTRADO ALGUNA VEZ

    role: Role;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    constructor(private ministerService: MinisterService,
        public generalService: GeneralService,
        private registrationService: RegistrationService,
        private _loginService: LoginService,
        private _rolesService: RolesService,
        private churchService: ChurchService,
        private _iglesiasService: IglesiasService,
        public dialog: MatDialog,
        private loadService: LoadService,
        private router: Router) {
        this.loadConcepts();
        this.loadMinisters();
        this.loadChurches();
    }

    ngOnInit() {
        this.registrationService.getDistricts()
            .subscribe((data: District[]) => {
                this.districts = data;
            })

        this._iglesiasService.getAllChurches()
            .subscribe((data: Church[]) => {
                this._iglesiasService.allChurches = data;

                //console.log('role', this.role);

                if (this.role.level == '2') {
                    this._rolesService.getDirectorDistrital(this.role.pivot.id)
                        .subscribe((data: AxisDistrictDirector) => {
                            //console.log('data info', data);
                            this.districtValue = data.district_id;
                            this.changeDistrict(this.districtValue);
                        })
                }
                else if (this.role.level == '3') {
                    this._rolesService.getSectionalCoordinatorPastoral(this.role.pivot.id)
                        .subscribe((data: SectionalCoordinatorPastoral) => {

                            //console.log('data info sectional', data);

                            this.districtValue = data.sectional.district.id;
                            this.changeDistrict(this.districtValue);

                            this.sectionalValue = data.sectional_id;
                            this.changeSectional(this.sectionalValue);

                        })
                }

            })

        //this.dataSource = new MatTableDataSource(this.allMinisters);
        // this.dataSource = new MinisterDataSource(this.ministerService);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        this.role = this._loginService.getInfoRole();


    }

    loadConcepts() {
        this.ministerStates = this.generalService.concepts[13];
        if (this.ministerStates == null) {
            this.generalService.getConceptDataById(13).subscribe((data: Concept) => {
                this.ministerStates = data.values;
                this.generalService.concepts[13] = data.values;
            });
        }

        this.ministerialTrainingTypes = this.generalService.concepts[12];
        if (this.ministerialTrainingTypes == null) {
            this.generalService.getConceptDataById(12).subscribe((data: Concept) => {
                this.ministerialTrainingTypes = data.values;
                this.generalService.concepts[12] = data.values;
            });
        }

        this.ministerLevels = this.generalService.concepts[10];
        if (this.ministerLevels == null) {
            this.generalService.getConceptDataById(10).subscribe((data: Concept) => {
                this.ministerLevels = data.values;
                this.generalService.concepts[10] = data.values;
            });
        }

        this.fulfillmentStates = this.generalService.concepts[7];
        if (this.fulfillmentStates == null) {
            this.generalService.getConceptDataById(7).subscribe((data: Concept) => {
                this.fulfillmentStates = data.values;
                this.generalService.concepts[7] = data.values;
            });
        }
    }

    loadMinisters() {
        this.ministerService.getMinisters().subscribe(
            (data: Minister[]) => {
                this.allMinisters = data;

                //console.log('all Ministers', this.allMinisters);

                this.allMinisters.forEach(minister => {
                    this.generalService.ministers[minister.id] = minister;
                });

                this.ministersResult = this.allMinisters;

                //this.dataSource = new MatTableDataSource(this.allMinisters);
                this.dataSource = new MatTableDataSource(this.ministersResult);

                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;

                this.resourcesHasLoaded = true;
            },
            (error) => {
                console.log('error', error);

                this.isAuthorized = false;
                this.resourcesHasLoaded = true;
            });
    }

    loadChurches() {
        this.churchService.getChurches()
            .subscribe((churchData: Church[]) => {
                churchData.forEach(church => {
                    this.generalService.churches[church.id] = church;
                });
            },
                (error) => {
                    console.log('error', error);
                });
    }

    getMinisterLevelName(level) {
        let levelName = '';
        Object.keys(this.generalService.concepts[10]).forEach((key, index) => {
            if (this.generalService.concepts[10][key].value === level) {
                levelName = this.generalService.concepts[10][key].description;
            }
        });
        //console.log('level', levelName);
        return levelName;
    }

    getMinisterTypeName(type) {
        let typeName = '';
        Object.keys(this.generalService.concepts[13]).forEach((key, index) => {
            if (this.generalService.concepts[13][key].value === type) {
                typeName = this.generalService.concepts[13][key].description;
            }
        });
        return typeName;
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        this.dataSource.filter = filterValue;
    }

    applyMinisterStateFilter(filterStateValue: ConceptValues) {
        this.ministerStateObjValue = filterStateValue;
        this.dataSource.filter = '';
        this.dataSource.filter = filterStateValue.value;
    }

    applyMinisterLevelFilter(filterLevelValue: ConceptValues) {

        //console.log('level', filterLevelValue);

        this.ministerLevelObjValue = filterLevelValue;

        this.filterByMinisterLevel(filterLevelValue.value);
    }

    filterByMinisterLevel(level: string) {
        this.dataSource.data = this.ministersResult.filter((minister) => {
            return minister.level == level;
        })
    }


    clearFilters() {
        this.dataSource.filter = '';
        this.ministerStateValue = '';
        this.fulfillmentStateValue = '';
        this.inputFilterValue = '';
        this.ministerStateObjValue = undefined;
    }

    removeLevelFilter() {
        this.ministerLevelObjValue = null;

        if (this.firstTimeFiltered) {
            this.filterMinistersByChurches(this.churchesSelected);
        }
        else {
            this.dataSource.data = this.allMinisters;
        }

    }

    downloadMinisters() {
        csvOptions['headers'] = ['Nombre', 'Iglesia', 'Tipo', 'Nivel', 'Credencial', 'Fecha de vencimiento credencial', 'Teléfono', 'Teléfono celular', 'Labor ministerial', 'Nombre de esposa', 'Años casados', 'Comienzo como ministro', 'Seminario bíblico', 'ISUM', 'FATAD', 'Otro'];

        //console.log('ministros a imprimir', this.ministersResult);


        const csvMinisters = this.ministersResult.map((minister) => {
            minister['seminarioBiblico'] = 'No';
            minister['isum'] = 'No';
            minister['fatad'] = 'No';
            minister['otro'] = 'No';

            minister.ministerial_trainings.forEach((ministerialTraining) => {
                switch (ministerialTraining.type) {
                    case '01':
                        minister['seminarioBiblico'] = 'Si';
                        break;
                    case '02':
                        minister['isum'] = 'Si';
                        break;
                    case '03':
                        minister['fatad'] = 'Si';
                        break;
                    case '04':
                        minister['otro'] = 'Si';
                        break;
                }
            })

            return {
                nombre: `${minister.user.name} ${minister.user.surname} ${minister.user.second_surname}`,
                iglesia: minister.church.name,
                tipo: this.getMinisterTypeName(minister.minister_type),
                nivel: this.getMinisterLevelName(minister.level),
                credencial: minister.credential,
                expiry_date_credential: minister.expiry_date_credential,
                telefono: minister.phone,
                telefonoCelular: minister.cell_phone,
                laborMinisterial: minister.labor_ministry,
                nombreEsposa: minister.spouse_name,
                anosCasados: minister.married_years,
                startDate: minister.ministry_start_date,
                seminarioBiblico: minister['seminarioBiblico'],
                isum: minister['isum'],
                fatad: minister['fatad'],
                otro: minister['otro']


            }
        })

        const data = new Angular5Csv(csvMinisters, 'Ministros', csvOptions);

    }

    changeDistrict(districtValue) {
        //console.log('Filtrar por distrito', districtValue);

        this.cities = [];
        this.churches = [];

        this._iglesiasService.getChurchesByDistrict(districtValue)
            .then((data: Church[]) => {
                //console.log('ejecutando');

                this.filterMinistersByChurches(data);

            }, (error) => {
                console.log('Hubo un error distritos');
            });

        if (districtValue) {
            this.registrationService.getDistrictDataById(districtValue)
                .subscribe((districtData: any) => {

                    this.sectionals = districtData.sectionals

                });
        }

    }

    changeSectional(sectionalValue) {
        //console.log('Filtrar por seccional', sectionalValue);

        this.churches = [];

        this._iglesiasService.getChurchesBySectional(sectionalValue)
            .then((data: Church[]) => {
                this.filterMinistersByChurches(data);
            })
            .catch(() => {
                console.log('Hubo un error seccionales');
            })

        this.registrationService.getSectionalDataById(sectionalValue)
            .subscribe((data: any) => {
                this.cities = data.cities;
            }, (error) => {
                console.log('Hubo un error');
            })

    }

    changeCity(cityValue) {
        this.churches = [];

        this._iglesiasService.getChurchesByCity(cityValue)
            .then((data: Church[]) => {

                this.churches = data;

                this.filterMinistersByChurches(data);
            })
            .catch((error) => {
                console.log('Hubo un error');
            })
    }

    changeChurch(churchValue) {
        this._iglesiasService.getChurchById(churchValue)
            .then((church: Church) => {

                let data: Church[] = [];
                data.push(church);

                this.filterMinistersByChurches(data);
            })
            .catch((error) => {
                console.log('No se encontró la iglesia');

                this.filterMinistersByChurches([]);
            })
    }

    filterMinistersByChurches(data: Church[]) {

        this.firstTimeFiltered = true;

        this.churchesSelected = data;

        this.ministersResult = [];
        //console.log('Filtrando iglesias');

        data.forEach((church) => {
            this.allMinisters.forEach((minister) => {
                if (church.id == minister.church_id) {
                    this.ministersResult.push(minister);
                }
            })
        })

        if (this.ministerLevelObjValue) {
            this.filterByMinisterLevel(this.ministerLevelObjValue.value);
        }
        else {
            this.dataSource.data = this.ministersResult;
        }


    }
}

const csvOptions = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalseparator: '.',
    showLabels: true
};


// WEBPACK FOOTER //
// ./src/app/admin/pages/ministers/minister-list/minister-list.component.ts